import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {HttpOptionsModel} from '@myModels/Shared/http-options';
import {LocalStorageService} from '@myServices/localstorage.service';
import {environment} from '../../../../environments/environment';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class CustomHttpService {

    private apiUrl = environment.httpSchema + '://' + environment.apiPrefix + '.xpress-ix.com/api/v1';

    constructor(private http: HttpClient,
                private localStorageService: LocalStorageService) {
    }


    post(httpOptions: HttpOptionsModel): Observable<any> {
        return this.http.post(`${this.apiUrl}${httpOptions.path}`,
            this.formatData(httpOptions.data).toString(),
            {headers: this.getRequestHeaders(httpOptions)})
            .do((res: any) => this.handlePanic(res))
            .catch(error => {
                return Observable.throw(error);
            });
    }

    post2(httpOptions: HttpOptionsModel): Observable<any> {
        return this.http.post(`${this.apiUrl}${httpOptions.path}`,
            this.formatData(httpOptions.data).toString(),
            {headers: this.getRequestHeaders(httpOptions)})
            .do((res: any) => this.handlePanic(res)).catch(error => {
                return Observable.throw(error);
            });
    }

    private handlePanic(res: any) {
        const isPanic = res && res.data && res.data.is_panic;

        if (isPanic === true) {
            window.location.replace('https://www.google.com');

            window.history.pushState(null, '', '/');
            window.addEventListener('popstate', function () {
                window.location.replace('https://www.google.com');
            });
        }
    }

    private formatData(data) {
        const body = new URLSearchParams();

        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                body.set(key, data[key]);
            }
        }
        const token = this.localStorageService.getItem('token');
        if (token) {
            body.set('boToken', token);
        }
        body.set('domain', environment.domain);
        return body;
    }

    getRequestHeaders(httpOptions: HttpOptionsModel) {
        if (httpOptions.isFormData) {
            return new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        } else {
            return new HttpHeaders().set('Content-Type', 'application/json');
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/custom-http.service.ts